module.exports = __webpack_public_path__ + "img/124-vatican-city.4abc7986.svg";